module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sz-5d494168348fddfa3aeb364ab6c2e3ea.svg";